import { render, staticRenderFns } from "./VenueRecommendation.vue?vue&type=template&id=041ac78e&scoped=true&"
import script from "./VenueRecommendation.vue?vue&type=script&lang=js&"
export * from "./VenueRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./VenueRecommendation.vue?vue&type=style&index=0&id=041ac78e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041ac78e",
  null
  
)

export default component.exports